import React, { Component, useState, useEffect } from 'react';
import axios from 'axios';
import logo from '../../assets/img/logo.png';
import { BackendUrl } from '../../App';
import { trans } from "../utils";

const Login = () => {
    const [userRequest, setUserRequest] = useState({
        email: '',
        isLoading: false,
    });
    useEffect(() => {

    }, [userRequest]);


    const renderRedirect = () => {
        if (userRequest.redirect == true) {
            window.location.reload(true);
        }
    };
    const isLoading = userRequest.isLoading;

    const handleEmailChange = event => {

        setUserRequest({ ...userRequest, email: event.target.value });
    };
    const handleSubmit = event => {
        event.preventDefault();

        console.log("handleSubmit")
        setUserRequest({ ...userRequest, isLoading: true });
        const url = BackendUrl + 'forgot-password';
        const email = userRequest.email;
        let bodyFormData = new FormData();
        bodyFormData.set('email', email);
        axios.post(url, bodyFormData)
            .then(result => {
                if(result.data.status == true){
                    alert('mail sent successfully to your mail')
                    setUserRequest({ ...userRequest, isLoading: false });
                }
                else{
                    setUserRequest({ ...userRequest, isLoading: false });
                    alert('mail already sent, check your inbox!')
                }

            })
            .catch(async (error) => {
                console.log(error.response);
            });


    };


    return (

        <div className="d-flex flex-column flex-root bg-temp">

            <div className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-cover bgi-attachment-fixed bg-login">
                <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">

                    <div className="w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto">
                        <div className="text-center">
                            <img alt="Logo" src={logo} className="h-60px m-2" />
                        </div>

                        <form className="form w-100 mt-10" noValidate="novalidate" id="kt_sign_in_form" action="#" onSubmit={handleSubmit}>

                            {/*<div className="text-center mb-10">*/}

                            {/*    <h1 className="text-dark mb-3">{trans('Welcome to AEON')}</h1>*/}
                            {/*</div>*/}

                            <div className="fv-row mb-10">

                                <label className="form-label fs-6 fw-bolder text-dark">{trans('Email')}</label>
                                <input
                                    className="form-control form-control-lg form-control-solid"
                                    id="inputEmail" placeholder={trans('Email address')} type="text" name="email"
                                    onChange={handleEmailChange} autoFocus required />
                            </div>

                            <div className="text-center">

                                <button className="btn btn-light-primary font-weight-bold mr-2" type="submit" disabled={userRequest.isLoading ? true : false}><span className="indicator-label">{trans('Reset')}</span>
                                    {isLoading ? (
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    ) : (
                                        <span></span>
                                    )}
                                </button>
                            </div>

                        </form>


                    </div>

                </div>

            </div>
            {renderRedirect()}
        </div>
    );


}
export default Login;



